import { Component, Inject, OnInit } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";

@Component({
  selector: "redeemBenefitDialog",
  templateUrl: "./redeemBenefitDialog.component.html",
  styleUrls: ["./redeemBenefitDialog.component.scss"]
})
export class RedeemBenefitDialogComponent implements OnInit {

  constructor(public bottomSheetRef: MatBottomSheetRef<RedeemBenefitDialogComponent, "store" | "online">) { }

  ngOnInit() { }


  public redeemInStore() {
    const me = this;
    me.bottomSheetRef.dismiss("store");
  }

  public redeemOnline() {
    const me = this;
    me.bottomSheetRef.dismiss("online");
  }

}
